import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import MainCondition from "../condition/MainCondition";
import ViewAPI from "../../../api/ViewAPI";
import withRouter from "../../../util/WithRouter";
import Const from "../../../util/Constants";
import Util from "../../../util/Util";
import Display from "../../../util/Display";
import ApiUiController from "../../../controller/ApiUiController";
import FieldText from "../../common/FieldText";
import FieldSelect from "../../common/FieldSelect";
import FieldMultiSelect from "../../common/FieldMultiSelect";
import FieldController from "../../../controller/FieldController";

class ViewUpdate extends React.Component {
  constructor(props) {
    super(props);
    const id = parseInt(props.match.params.id);

    this.Orders = [
      { label: "Descending", value: -1 },
      { label: "Ascending", value: 1 },
    ];

    this.state = {
      inApiCall: id !== 0,
      inValid: {},
      changed: false,
      conditions: [],
      view: {
        id,
        name: "",
        type: -1,
        model: 0,
        sortField: "",
        sortOrder: this.Orders[0].value,
      },
    };

    this.mainModel = reactLocalStorage.getObject(Const.Model);
    this.mainModel.view.fields.model.options = [
      {
        label: this.mainModel.lead.model_name,
        value: this.mainModel.lead.model_no,
      },
      {
        label: this.mainModel.contact.model_name,
        value: this.mainModel.contact.model_no,
      },
      {
        label: this.mainModel.call.model_name,
        value: this.mainModel.call.model_no,
      },
      {
        label: this.mainModel.meeting.model_name,
        value: this.mainModel.meeting.model_no,
      },
      {
        label: this.mainModel.property.model_name,
        value: this.mainModel.property.model_no,
      },
      {
        label: this.mainModel.sales_order.model_name,
        value: this.mainModel.sales_order.model_no,
      },
      {
        label: this.mainModel.project.model_name,
        value: this.mainModel.project.model_no,
      },
      {
        label: this.mainModel.installment.model_name,
        value: this.mainModel.installment.model_no,
      },
      {
        label: this.mainModel.user.model_name,
        value: this.mainModel.user.model_no,
      },
    ];

    this.model = null;
    this.fields = [];
    this.viewFields = [{}];
    this.sameAsMobile = false;
    this.viewMobileFields = [{}];

    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.lastIndexOf("/"));

    this.conditions = [];
    this.updates = [{}];
    this.autoModel = {};
    this.autoAction = {};
  }

  componentDidMount() {
    if (this.state.view.id !== 0) {
      ViewAPI.get(this.state.view.id, this.onReceived, this.onFail);
    }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  onReceived = (view) => {
    if (view.type === 1) {
      this.mainModel.view.fields.roles.editable = 0;
      this.mainModel.view.fields.users.editable = 0;
    } else if (view.type === 2) {
      this.mainModel.view.fields.roles.editable = 1;
      this.mainModel.view.fields.users.editable = 0;
    } else if (view.type === 3) {
      this.mainModel.view.fields.roles.editable = 0;
      this.mainModel.view.fields.users.editable = 1;
    } else if (view.type === 0) {
      this.mainModel.view.fields.roles.editable = 1;
      this.mainModel.view.fields.users.editable = 1;
    }

    const model = Object.keys(this.mainModel).find(
      (key) => this.mainModel[key].model_no === view.model
    );
    this.model = this.mainModel[model];
    this.fields = FieldController.getFilterFields(this.model.fields);

    this.conditions = view.filters ? JSON.parse(view.filters) : [];

    view.fields = view.fields ? JSON.parse(view.fields) : [];
    let fields = this.fields.map((item) => {
      return {
        id: item.id,
        value: item.fieldKey,
        type: item.field_type,
        label: item.label_name,
      };
    });
    this.viewFields = view.fields.map((field) =>
      fields.find((item) => field === item.value)
    );
    if (this.viewFields.length === 0) {
      this.viewFields = [{}];
    }

    view.mobile_fields = view.mobile_fields
      ? JSON.parse(view.mobile_fields)
      : [];
    fields = this.fields.map((item) => {
      return {
        id: item.id,
        value: item.fieldKey,
        type: item.field_type,
        label: item.label_name,
      };
    });
    this.viewMobileFields = view.mobile_fields.map((field) =>
      fields.find((item) => field === item.value)
    );
    if (this.viewMobileFields.length === 0) {
      this.viewMobileFields = [{}];
    }

    this.sameAsMobile = view.fields === view.mobile_fields;

    this.setState({
      ...this.state,
      view: { ...view },
      inApiCall: false,
      inValid: {},
    });
  };

  onValueChange = (field, value) => {
    const view = { ...this.state.view };
    view[field] = value;
    if (field === "type" && value === 1) {
      this.mainModel.view.fields.roles.editable = 0;
      this.mainModel.view.fields.users.editable = 0;
    } else if (field === "type" && value === 2) {
      this.mainModel.view.fields.roles.editable = 1;
      this.mainModel.view.fields.users.editable = 0;
    } else if (field === "type" && value === 3) {
      this.mainModel.view.fields.roles.editable = 0;
      this.mainModel.view.fields.users.editable = 1;
    } else if (field === "type" && value === 0) {
      this.mainModel.view.fields.roles.editable = 1;
      this.mainModel.view.fields.users.editable = 1;
    }
    if (field === "model") {
      const model = Object.keys(this.mainModel).find(
        (key) => this.mainModel[key].model_no === value
      );
      if (model) {
        this.model = this.mainModel[model];
        this.fields = FieldController.getFilterFields(this.model.fields);
      } else {
        this.model = null;
        this.fields = [];
      }
    }
    this.setState({ ...this.state, view: { ...view }, inValid: {} });
  };

  onConditionChanged = (conditions) => (this.conditions = conditions);

  onFieldChange = (type, i, selected) => {
    if (type === "viewField") {
      this.viewFields[i] = selected;
    } else if (type === "viewMobileField") {
      this.viewMobileFields[i] = selected;
    }
    this.setState({ ...this.state, changed: !this.state.changed });
  };
  onFieldAdd = () => {
    this.viewFields.push(null);
    this.setState({ ...this.state, changed: !this.state.changed });
  };
  onFieldDelete = (index) => {
    this.viewFields = this.viewFields.filter((_, i) => i !== index);
    this.setState({ ...this.state, changed: !this.state.changed });
  };
  onUp = (index) => {
    const tmp = this.viewFields[index];
    this.viewFields[index] = this.viewFields[index - 1];
    this.viewFields[index - 1] = tmp;
    this.setState({ ...this.state, changed: !this.state.changed });
  };
  onDown = (index) => {
    const tmp = this.viewFields[index];
    this.viewFields[index] = this.viewFields[index + 1];
    this.viewFields[index + 1] = tmp;
    this.setState({ ...this.state, changed: !this.state.changed });
  };

  onChecked = (event) => {
    this.sameAsMobile = event.target.checked;
    if (this.sameAsMobile) {
      this.viewMobileFields = [...this.viewFields];
    }
    this.setState({ ...this.state, changed: !this.state.changed });
  };

  onFieldAddMobile = () => {
    this.viewMobileFields.push(null);
    this.setState({ ...this.state, changed: !this.state.changed });
  };
  onFieldDeleteMobile = (index) => {
    this.viewMobileFields = this.viewMobileFields.filter((_, i) => i !== index);
    this.setState({ ...this.state, changed: !this.state.changed });
  };
  onUpMobile = (index) => {
    const tmp = this.viewMobileFields[index];
    this.viewMobileFields[index] = this.viewMobileFields[index - 1];
    this.viewMobileFields[index - 1] = tmp;
    this.setState({ ...this.state, changed: !this.state.changed });
  };
  onDownMobile = (index) => {
    const tmp = this.viewMobileFields[index];
    this.viewMobileFields[index] = this.viewMobileFields[index + 1];
    this.viewMobileFields[index + 1] = tmp;
    this.setState({ ...this.state, changed: !this.state.changed });
  };

  onSortFieldChange = (field) =>
    this.setState({
      ...this.state,
      view: { ...this.state.view, sortField: field },
    });
  onSortOrderChange = (order) =>
    this.setState({
      ...this.state,
      view: { ...this.state.view, sortOrder: order },
    });

  onSave = () => {
    this.setState({ ...this.state, inApiCall: true });
    const view = { ...this.state.view };

    view.filters = this.conditions
      .filter((item) => Object.keys(item).length !== 0)
      .map((filter) => {
        return {
          field: filter.field?.value,
          type: filter.field.type,
          condition: filter.condition?.value,
          value: filter?.value,
        };
      });
    view.filters = JSON.stringify(view.filters);

    view.fields = this.viewFields
      .filter((field) => {
        return field ? true : false;
      })
      .map((field) => field.value);
    view.fields = JSON.stringify(view.fields);

    view.mobile_fields = this.viewMobileFields
      .filter((field) => {
        return field ? true : false;
      })
      .map((field) => field.value);
    view.mobile_fields = JSON.stringify(view.mobile_fields);

    ViewAPI.save(view, this.onSaved, this.onFail);
  };

  onSaved = () => {
    Util.showNotification("Successful", "Successfully saved.", "success");
    this.props.navigate(this.basePath);
  };

  render() {
    const fields = this.fields.map((item) => {
      return {
        id: item.id,
        value: item.fieldKey,
        type: item.field_type,
        label: item.label_name,
      };
    });

    let fieldOrders = fields.filter(
      (field) =>
        field.type === Const.Date ||
        field.type === Const.DateTime ||
        field.type === Const.Number ||
        field.type === Const.Decimal ||
        field.type === Const.Double
    );
    fieldOrders = [
      { id: "id", value: "id", type: "number", label: "Id" },
      ...fieldOrders,
    ];

    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-12">
              <h3>View</h3>
            </div>
          </div>

          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form key="form" className="row row-cols-3 lead-form">
              <FieldText
                key="name"
                id="name"
                field={this.mainModel.view.fields.name}
                value={this.state.view.name}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              <FieldText
                key="view_order"
                id="view_order"
                field={this.mainModel.view.fields.view_order}
                value={this.state.view.view_order}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              <FieldSelect
                key="type"
                id="type"
                field={this.mainModel.view.fields.type}
                value={this.state.view.type}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              <FieldMultiSelect
                key="roles"
                id="roles"
                field={this.mainModel.view.fields.roles}
                value={this.state.view.roles}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              <FieldMultiSelect
                key="users"
                id="users"
                field={this.mainModel.view.fields.users}
                value={this.state.view.users}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              <FieldSelect
                key="model"
                id="model"
                field={this.mainModel.view.fields.model}
                value={this.state.view.model}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              <MainCondition
                model={this.model}
                fields={this.fields}
                eKey="conditions"
                value={this.conditions}
                onConditionChanged={this.onConditionChanged}
              />

              <div className="formhead col-md-12">
                <h4>Fields</h4>
              </div>
              {this.viewFields.map((field, i) => (
                <div
                  key={`view_field_${i}`}
                  className="col-md-12 condition-select-div"
                >
                  <div className="col-md-4">
                    <Select
                      value={field}
                      onChange={(item) =>
                        this.onFieldChange("viewField", i, item)
                      }
                      options={fields}
                      isMulti={false}
                      isSearchable={true}
                      className="mr-sm-2 assignselect"
                    />
                  </div>
                  {Display.MultiAction(i, this.onFieldAdd, this.onFieldDelete)}
                  {Display.UpDown(
                    i,
                    this.viewFields.length,
                    this.onUp,
                    this.onDown
                  )}
                </div>
              ))}

              <div className="formhead col-md-12">
                <h4>Mobile Fields</h4>
                <Form.Check
                  onChange={this.onChecked}
                  checked={this.sameAsMobile}
                />
                <label>Same As Desktop</label>
              </div>
              {this.viewMobileFields.map((field, i) => (
                <div
                  key={`view_field_${i}`}
                  className="col-md-12 condition-select-div"
                >
                  <div className="col-md-4">
                    <Select
                      value={field}
                      onChange={(item) =>
                        this.onFieldChange("viewMobileField", i, item)
                      }
                      options={fields}
                      isMulti={false}
                      isSearchable={true}
                      className="mr-sm-2 assignselect"
                    />
                  </div>
                  {Display.MultiAction(
                    i,
                    this.onFieldAddMobile,
                    this.onFieldDeleteMobile
                  )}
                  {Display.UpDown(
                    i,
                    this.viewMobileFields.length,
                    this.onUpMobile,
                    this.onDownMobile
                  )}
                </div>
              ))}

              <div className="formhead col-md-12">
                <h4>Order By</h4>
              </div>
              <div className="col-md-12 condition-select-div">
                <div className="col-md-4">
                  <Select
                    value={fieldOrders.find(
                      (field) => field.value === this.state.view.sortField
                    )}
                    onChange={(item) => this.onSortFieldChange(item.value)}
                    options={fieldOrders}
                    isMulti={false}
                    isSearchable={true}
                    isClearable={false}
                    className="mr-sm-2 assignselect"
                  />
                </div>
                <div className="col-md-4">
                  <Select
                    value={this.Orders.find(
                      (field) => field.value === this.state.view.sortOrder
                    )}
                    onChange={(item) => this.onSortOrderChange(item.value)}
                    options={this.Orders}
                    isMulti={false}
                    isSearchable={true}
                    isClearable={false}
                    className="mr-sm-2 assignselect"
                  />
                </div>
              </div>

              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>
                  Save
                </Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(ViewUpdate);
